import React, { useContext, useEffect, useState } from "react";
import TextField from '@mui/material/TextField';
import { Button, Col } from "react-bootstrap";
import blogFetch from "../../../axios/config";
import Context from "../../../context/Context";
import Loading from "../../../components/Loading";
import NoImage from "../../../assests/NoImage.jpg"
import { PhotoModal } from "./PhotoModal";
import { QrCode } from "./QrCode";
import toast from "react-hot-toast";
import BarcodeScannerModal from "./BarCodeReader";
import '../ValidacaoLogo.css'
import { DateTimeFmt } from "../../../utils/DataUtils";
import { InfoEtiqueta } from "./InfoEtiqueta";

export const ValidacaoLogoComponent = () => {

  const {
    loading,
    setLoading
  } = useContext(Context);

  const [etiqueta, setEtiqueta] = useState(null)
  const [takePhoto, setTakePhoto] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [code, setCode] = useState("");
  const [isUrlValid, setIsUrlValid] = useState(false);
  const [maxHeight, setMaxHeight] = useState(350);
  //const [isQr, setIsQr] = useState(true)

  useEffect(() => {
    if (code) {
      getSapEtiqueta(code)
    }
  }, [code]);

  const getSapEtiqueta = async (lote) => {
    setLoading(true)
    try {
      const { data } = await blogFetch.get(`SAP_Etiqueta_Logistica/${lote}`)
      setEtiqueta(data)
      //haveQRCode(data.mercado, data.logoID)
    } catch {
      console.error("Error")
    } finally {
      setLoading(false)
    }
  }

  const postEtiquetaConferencia = async (formData) => {
    setLoading(true)
    try {
      await blogFetch.post(`SAGA_ConferenciaLogo`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      toast.success("Dados salvos com sucesso", {
        duration: 4000,
      });
      clearFields()
    } catch (e) {
      console.error(e)
      toast.error("Erro ao salvar dados", {
        duration: 4000,
      });
    }
    finally {
      setLoading(false)
    }
  }

  

  const user = JSON.parse(localStorage.getItem('user'));



  const formPostEtiquetaConferencia = () => {
    const formData = new FormData();
    formData.append("entryFile", takePhoto.url);
    formData.append("Conf_Lote", etiqueta.lote)
    formData.append("Conf_Logo", etiqueta.logoID)
    formData.append("Conf_QRCodeOK", 1)
    formData.append("Conf_Client", etiqueta.cliente)
    formData.append("Conf_Verificado", false)
    formData.append("Conf_Status", "VERIFICAR")
    formData.append("_Creat", user.user_Matricula)
    formData.append('Conf_ResVerificado', user.user_Matricula)

    postEtiquetaConferencia(formData)
  }

  const handleInput = ({ target }) => {
    const { value } = target;
    setCode(value)
  }

  const handleKeyDown = async (e) => {
    if (e.key === "Enter" || e.key === 'Tab' || e.key === 'NumpadEnter') {
      getSapEtiqueta(code)
    }
  }

  const clearFields = async () => {
    setCode("")
    setEtiqueta(null)
    setImageUrl(null)
    setTakePhoto(null)
    //setIsQr(true)
  }

  const handleImageLoad = (event) => {
    const img = event.target
    const height = img.naturalHeight

    if (height > 300) {
      setMaxHeight(300)
    }
  }

  // const haveQRCode = (mercado, logoId) => {
  //   switch (mercado) {
  //     case "MÉXICO":
  //       setIsQr(false)
  //   }
  //   switch (logoId) {
  //     case "CO-0279":
  //     case "CO-1111":
  //     case "7402-G":
  //     case "7404-P":
  //     case "7505-P":
  //     case "PE-691":
  //       setIsQr(false)
  //   }
  // }


  console.log(etiqueta);
  

  return (
    <>
      <Col>
        <div className="d-flex">
          <TextField
            value={code}
            className="p-2"
            fullWidth
            label="Leitor"
            autoComplete="off"
            autoFocus
            onChange={handleInput}
            onKeyDown={handleKeyDown}
          />
          {etiqueta && (
            <TextField
              className="p-2 "
              disabled
              label="Logo ID"
              defaultValue={etiqueta.logoID}
              onChange={handleInput}
              onKeyDown={handleKeyDown}
              sx={{
                '& .MuiInputBase-input.Mui-disabled': {
                  WebkitTextFillColor: 'black',
                },
              }}
            />
          )}
          <Button
            className="m-2"
            onClick={clearFields}
          >
            LIMPAR
          </Button>
          <BarcodeScannerModal
            code={code}
            setCode={setCode}
            clearFields={clearFields}
          />
        </div>
        {!loading ?
          <div>
            {etiqueta && (
              <div>
                <div className="m-3 text-center">
                  <div
                    className={`m-3 p-2 rounded ${etiqueta.pedido_Produto?.includes("iB33") ? "bg-yellow-300" : ""}`}
                    style={
                      etiqueta.pedido_Produto?.toLowerCase().includes("ib") || etiqueta.pedido_Produto?.toLowerCase().includes("i-b")
                        ? { border: "3px solid red",  animation: 'pulse 1s infinite' } 
                        : {}
                    }
                  >
                    <img
                      style={{ maxWidth: "600px", maxHeight: `${maxHeight}px` }}
                      src={etiqueta.logoUrl}
                      alt="Logo"
                      onLoad={handleImageLoad}
                    />

                    { etiqueta.pedido_Produto?.toLowerCase().includes("ib") ||etiqueta.pedido_Produto?.toLowerCase().includes("i-b") ? (
                              <h1 className="bold">ATENÇÃO</h1>
                            ) : null}
                  </div>
                  <div className="m-3">
                    {!imageUrl ? (
                      <img
                        style={{ maxWidth: "400px" }}
                        src={NoImage}
                        alt="noimage"
                      />
                    ) : (
                      <img
                        src={imageUrl}
                        style={{ maxWidth: "400px" }}
                        alt="imageurl"
                      />
                    )}
                  </div>
                </div>
                <div className="text-end mt-5">
                  <InfoEtiqueta
                    etiqueta={etiqueta}
                  />
                  {/* {isQr && (
                    <QrCode
                      setIsUrlValid={setIsUrlValid}
                      isUrlValid={isUrlValid}
                    />
                  )} */}
                  <PhotoModal
                    lote={etiqueta}
                    takePhoto={takePhoto}
                    setTakePhoto={setTakePhoto}
                    imageUrl={imageUrl}
                    setImageUrl={setImageUrl}
                  //setIsUrlValid={setIsUrlValid}
                  />
                  <Button
                    onClick={formPostEtiquetaConferencia}
                    disabled={!takePhoto}
                  >
                    SALVAR
                  </Button>
                </div>
              </div>
            )}
          </div>
          : (<Loading />)}
      </Col>
    </>
  )
}